// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2tyMX","selected":"Chip_selected__UPHBh"};